var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"PageHeader"},[(_vm.hasBackButton)?_c('Icon',{staticClass:"PageHeader__Icon",attrs:{"icon":"arrow-left"},on:{"click":_vm.handleClick}}):_vm._e(),_c('div',{staticClass:"PageHeader__Title"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }